import FeedbackPage from '@/components/FeedbackPage'

export default function ExperienceFeedbackPage() {
  return (
    <FeedbackPage
      emoji="🙌"
      title="pages.onboarding.experienceFeedback.title"
    />
  )
}
